/**
 * Global App Config
 *
 */

import AppAPI from './api';

let environment = 'production';
if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  environment = process.env.REACT_APP_ENVIRONMENT;
}


export default {
  // App Details
  appName: 'Renzo',
  DEV: (environment !== 'production'),
  environment: environment,
  endpoint: AppAPI.hostname,
  hostname: '//renzo.in',
  paymentHostname: '//payments.renzo.in',
  dashboardHostname: '//dashboard.renzo.in'
};



// WEBPACK FOOTER //
// ./src/constants/config.js